import React, { useEffect, useState } from 'react';
import css from './HelpCenter.module.css';
import qAndA from './questions-answers';
import { FormattedMessage } from '../../../util/reactIntl';
import classNames from 'classnames';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import NamedLink from '../../NamedLink/NamedLink';
import { useLocation } from 'react-router-dom';

const HelpCenter = () => {
  const [currentContent, setCurrentContent] = useState(
    qAndA.howItWorks.questionsAndAnswers
  );

  const [activeTab, setActiveTab] =
    useState('howItWorks');

  const [activeAccordionItem, setActiveAccordionItem] =
    useState(null);

  const location = useLocation();

  const searchParams = new URLSearchParams(
    location.search
  );

  const tab = searchParams.get('tab');
  const question = searchParams.get('question');

  const tabMapping = {
    'shipping-returns': 'shippingAndReturns',
    'verification-security':
      'verificationAndSecurity',
    'registration-login':
      'registrationAndLogin',
    'buy-sell': 'buyAndSell',
    'how-it-works': 'howItWorks',
  };

  useEffect(() => {
    if (tab && tabMapping[tab]) {
      const mappedTab = tabMapping[tab];

      const tabContent =
        qAndA[mappedTab].questionsAndAnswers;

      setActiveTab(mappedTab);
      setCurrentContent(tabContent);

      if (question) {
        setActiveAccordionItem(question);

        setTimeout(() => {
          const element =
            document.getElementById(question);

          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }, 200);
      } else {
        setActiveAccordionItem(null);
      }
    }
  }, [tab, question, location.search]);

  const handleTabClick = tab => {
    setCurrentContent(
      qAndA[tab].questionsAndAnswers
    );

    setActiveTab(tab);

    setActiveAccordionItem(null);
  };

  const handleAccordionToggle = id => {
    if (id !== activeAccordionItem) {
      setActiveAccordionItem(id);
      return;
    }

    setActiveAccordionItem(null);
  };

  return (
    <div className={css.content}>
      <div className={css.tabs}>
        {Object.keys(qAndA).map(tab => (
          <button
            key={tab}
            type="button"
            className={classNames(
              css.tabButton,
              {
                [css.isActive]:
                  activeTab === tab,
              }
            )}
            onClick={() =>
              handleTabClick(tab)
            }
          >
            {qAndA[tab].icon}

            <FormattedMessage
              id={qAndA[tab].tabTitleIntl}
            />
          </button>
        ))}
      </div>

      <div className={css.accordion}>
        {currentContent.map((item, index) => {
          const accordionId =
            item.id || item.question;

          return (
            <div
              id={accordionId}
              className={css.accordionItem}
              key={item.question}
            >
              <button
                type="button"
                className={css.accordionHeader}
                onClick={() =>
                  handleAccordionToggle(
                    accordionId
                  )
                }
              >
                <span>
                  <FormattedMessage
                    id={item.question}
                  />
                </span>

                <span className={css.toggleIcon}>
                  {accordionId ===
                  activeAccordionItem ? (
                    <Minus />
                  ) : (
                    <Plus />
                  )}
                </span>
              </button>

              <div
                className={classNames(
                  css.accordionContent,
                  {
                    [css.isOpen]:
                      accordionId ===
                      activeAccordionItem,
                  }
                )}
              >
                {(item.answer ===
                  'HelpCenter.ShippingAndReturns.a8' ||
                  item.answer ===
                    'HelpCenter.ShippingAndReturns.a3' ||
                  item.answer ===
                    'HelpCenter.ShippingAndReturns.a5') ? (
                  <FormattedMessage
                    id={item.answer}
                    values={{
                      link: chunks => (
                        <NamedLink name="ReturnPolicyPage">
                          {chunks}
                        </NamedLink>
                      ),
                    }}
                  />
                ) : (
                  <FormattedMessage
                    id={item.answer}
                  />
                )}

                {item.hasContact && (
                  <NamedLink
                    name="ContactPage"
                    className={css.contactUs}
                  >
                    <FormattedMessage id="HelpCenter.ContactUsButton" />
                  </NamedLink>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HelpCenter;